// ── DOT/EXT 매출 관리 — 통합 RevenueManagement 래퍼 ──────────────────────────
// 기존 독립 구현을 통합 RevenueManagement로 교체
// companyCode prop을 그대로 전달하여 apiBase/권한/tblPrefix 자동 분기
import React from 'react';
import RevenueManagement from '../revenuemgmt/RevenueManagement';

/**
 * DOT/EXT 매출 관리 페이지
 * @param {string} companyCode — 'DOT' 또는 외부사 코드 (App.js ExtRevenueRoute에서 전달)
 */
export default function AdminDotRevenuePage({ companyCode = 'DOT' }) {
  return <RevenueManagement companyCode={companyCode} />;
}
